const InfiniteScroll = require('infinite-scroll');

window.InitInfScroll = function() {
    if (document.querySelector('.js-paginator-holder')) {

        const paginationLinks = document.querySelector('.js-next-pagination');
        const paginationHolder = document.querySelector('.js-paginator-holder');
        const endOfContent = document.querySelector('.js-end-of-content');

        const perPage = paginationHolder.dataset.perpage;
        const nextPage = paginationHolder.dataset.nextlink;

        window.InfScroll = new InfiniteScroll(paginationHolder, {
            path: function setPath() {

                const link = nextPage;
                const current = (this.loadCount + 1) * perPage;
                return link.replace(/(start=)[^&]+/, '') + 'start=' + current;

            },
            append: paginationHolder.dataset.items,
            button: '.js-next-pagination',
            checkLastPage: true,
            scrollThreshold: false,
            debug: true,
            history: false,
            status: '.js-unit-loading',
        });

        window.InfScroll.on('append', function onAppend(response, path, items) {

            if (response.querySelector('.js-next-pagination')) {

                paginationLinks.style.display = 'inline-block';

            } else {

                if (endOfContent) {

                    endOfContent.style.display = 'inline-block';

                }
                paginationLinks.setAttribute('style', 'display:none !important');

            }
            setTimeout(function timeoutSet() {

                if (endOfContent) {

                    endOfContent.style.display = 'none';

                }

            }, 2000);

        });

        window.InfScroll.on('request', function onRequest(response, path) {

            paginationLinks.setAttribute('style', 'display:none !important');

        });

    }

};

window.destroyInfScroll = function () {
    if (window.InfScroll) {
        window.InfScroll.destroy();
        window.InfScroll = null;
    }
};

window.InitInfScroll();
